<template>
  <div class="imgBox">
       <el-upload
        action=""
        :auto-upload=false
        :multiple=true
        :file-list="imgList"
        :on-change="imgPreview"
        list-type="picture-card"
        accept="image/*"
        :limit="20"
        :disabled="delFlag"
        :on-preview="handlePictureCardPreview"
        :before-remove="handleBeforeRemove"
        :on-remove="handleRemove" :class="[isAdd?'hidden':'']"
      >
      <div slot="tip" class="el-upload__tip" v-if="max>1">最多上传{{max}}张，支持jpg、png格式图片</div>
      </el-upload>
      <!-- <span style="font-size:12px" v-if="max>1">最多上传{{max}}张，支持jpg、png格式图片</span> -->
      <el-dialog  title="图片展示" :visible.sync="dialogVisible" append-to-body center width="1100px" class="imgDialog">
        <img style="max-width:100%;" :src="dialogImageUrl" alt="">
      </el-dialog>

    </div>
</template>

<script>
export default {
  name: 'uploadImgs',
  props: {
    imgList: {
      type: Array,
      default: function () {
        return []
      }
    },
    max: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      dialogImageUrl: '',
      isAdd: false,
      dialogVisible: false,
      delFlag: false,
      index: 0

    }
  },
  created () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    if (this.imgList.length == this.max) {
      console.log('--')

      this.isAdd = true
    }
  },
  watch: {
    imgList: {
      handler (newName, oldName) {
        if (this.imgList.length == this.max) {
          console.log('--')

          this.isAdd = true
        }
      },
      deep: true
      // immediate: true
    }
  },
  methods: {
    // 图片上传
    handleRemove (file, fileList) {
      this.$emit('update:imgList', fileList)
      this.$emit('remove', file, this.index)
      if (fileList.length < this.max) {
        this.isAdd = false
      }
    },
    handleBeforeRemove (file, fileList) {
      console.log(file, fileList)
      fileList.map((item, index) => {
        if (file.id === item.id) {
          this.index = index
        }
      })
      return this.$confirm('是否执行此操作?', '系统提示')
    },
    imgPreview (file, fileList) {
      let fileName = file.name
      let regex = /(.jpg|.jpeg|.png)$/
      if (regex.test(fileName.toLowerCase())) {
        this.$emit('update:imgList', fileList)
        this.$emit('change', fileList)
        if (fileList.length < this.max) {
          this.isAdd = false
        } else {
          this.isAdd = true
        }
      } else {
        fileList.pop()
        this.$alert('请选择图片文件图', '系统提示')
        return false
      }
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    }
  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
.imgBox{
  margin: 22px 10px;
}

.hidden /deep/.el-upload--picture-card{
  display: none;
}
.imgDialog /deep/.el-dialog__body{
  text-align: center;
}
/deep/.el-upload-list--picture-card .el-upload-list__item {
    overflow: hidden;
    background-color: #fff;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    box-sizing: border-box;
    width: 148px;
    height: 148px;
    // margin: 0px 165px 8px 0;
    margin: 0px 25px 8px 0;
    display: inline-block;
}
</style>
